/* Lightweight scroll-reveal: homepage/main sections fade + rise as they enter view.
   No-FOUC: theme.liquid adds `ptc-anim` to <html> synchronously; this script reveals.
   Fails safe: if this never runs, theme.liquid's fallback timer un-hides everything. */
(function () {
  var d = document.documentElement;
  d.classList.add('ptc-anim-ready'); // cancels the fallback un-hide timer

  // Respect reduced motion and old browsers: reveal everything, no animation.
  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    d.classList.remove('ptc-anim');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('ptc-in');
        io.unobserve(e.target);
      }
    });
  // threshold 0 = reveal as soon as any part enters view. A ratio threshold (e.g. 0.08) can never be
  // reached by sections taller than ~12 viewports (blog list on mobile is ~12,700px), leaving them invisible.
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

  function observe() {
    var nodes = document.querySelectorAll('#MainContent > .shopify-section:not(.ptc-watch)');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.add('ptc-watch');
      io.observe(nodes[i]);
    }
  }

  function init() { observe(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Cross-document view transitions land as a fresh load (pageshow covers bfcache too).
  window.addEventListener('pageshow', init);

  // Theme editor: reveal the section being edited immediately so it never stays hidden.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList) {
      e.target.classList.add('ptc-watch', 'ptc-in');
    }
  });
})();
